import React from "react";
//MUI Components
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { ToastContainer, toast } from "react-toastify";
import ImageUploader from '../CreateProfile/ImageUploader';
import Button from '@mui/material/Button';
import RestoreIcon from '@mui/icons-material/Restore';

function AboutDetails({
  bio,
  handleChange,
  fetchProfileUploadData,
  data,
  contactNumber,
  contactEmail,
  userPreferences,
  setIsDirty,
  profileImageUploadUrls,
  setProfileImageUploadUrls,
  profileImageUploadStatuses,
  setProfileImageUploadStatuses,
  localProfileImageUrls,
  setLocalProfileImageUrls,
  profileUploadDataKeys,
  setProfileUploadDataKeys,
  myProfile
}) {

  const updateDirtyFlagAndSetLocalUrls = (urls) => {
    setIsDirty(true);
    setLocalProfileImageUrls(urls);
  }

  const handleRestoreImages = async () => {
    if (!myProfile?.photoKeys?.length) {
      toast.error('There was an issue in restoring the images, please refresh or try again later');
      return;
    }
    // Revoke current blob URLs before restoring
    localProfileImageUrls.forEach(url => {
      if (url && url.startsWith('blob:')) {
        URL.revokeObjectURL(url);
      }
    });
    fetchProfileUploadData(true);
  };

  return (
    <div>
      <ToastContainer />
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-2 gap-2">
            <div>
              <h4 className="text-lg font-semibold">Profile Images</h4>
              <p className="text-sm text-gray-500">Upload up to 3 profile images</p>
            </div>
            <Button
              variant="outlined"
              startIcon={<RestoreIcon />}
              onClick={handleRestoreImages}
            >
              Restore Images
            </Button>
          </div>
          <ImageUploader
            fetchImageUploadData={fetchProfileUploadData} 
            profileImageUploadUrls={profileImageUploadUrls}
            setProfileImageUploadStatuses={setProfileImageUploadStatuses}
            localProfileImageUrls={localProfileImageUrls}
            setLocalProfileImageUrls={updateDirtyFlagAndSetLocalUrls}
            profileImageUploadStatuses={profileImageUploadStatuses}
            setProfileImageUploadUrls={setProfileImageUploadUrls}
            profileUploadDataKeys={profileUploadDataKeys}
            setProfileUploadDataKeys={setProfileUploadDataKeys}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            label="Bio"
            fullWidth
            required
            aria-multiline
            error={data["bio"].error}
            helperText={data["bio"].error ? data["bio"].helperText : ""}
            name="bio"
            multiline
            variant="standard"
            value={bio}
            placeholder="Tell us about yourself"
            onChange={handleChange}
            rows={8}
          >{bio}</TextField>
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Partner Preferences"
            fullWidth
            required
            aria-multiline
            error={data["userPreferences"].error}
            helperText={data["userPreferences"].error ? data["userPreferences"].helperText : ""}
            name="userPreferences"
            multiline
            variant="standard"
            value={userPreferences}
            placeholder="Describe what you are looking for in your partner"
            onChange={handleChange}
            rows={8}
          >{userPreferences}</TextField>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            variant="standard"
            label="Contact Number"
            error={data["contactNumber"].error}
            helperText={
              data["contactNumber"].error
                ? data["contactNumber"].helperText
                : ""
            }
            fullWidth
            required
            name="contactNumber"
            value={contactNumber}
            placeholder="Enter your contact number"
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            variant="standard"
            label="Contact Email"
            fullWidth
            name="contactEmail"
            value={contactEmail}
            placeholder="Enter your contact Email"
            onChange={handleChange}
          />
        </Grid>
      </Grid>
    </div>
  );
}

export default AboutDetails;
